import React, { useState } from "react";
import Main from "../../components/layout/Main";
import { Form, Input, Button, List, message } from "antd";

function SuggestionsPage() {
  const [suggestions, setSuggestions] = useState([
    { name: "PlayerOne", text: "Add more PUBG tournaments." },
    { name: "GamerX", text: "Introduce 1v1 challenges for Fortnite." },
  ]);

  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    const newSuggestion = { name: values.name, text: values.suggestion };
    setSuggestions([newSuggestion, ...suggestions]);
    message.success("Thank you for your suggestion!");
    form.resetFields();
  };

  return (
    <Main>
      <section>
        <div className="suggestions-main-div">
          {/* Heading */}
          <div className="suggestions-heading-div">
            <h1>Game Suggestions</h1>
            <p>
              Share your ideas to improve our gaming platform. We value your
              feedback and suggestions!
            </p>
          </div>

          {/* Suggestion Form */}
          <div className="suggestions-form-div">
            <h2>Submit Your Suggestion</h2>
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              className="suggestion-form"
            >
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      if (!value || !value.trim()) {
                        return Promise.reject(new Error("Name is required"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter a valid email" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>

              <Form.Item
                label="Suggestion"
                name="suggestion"
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      if (!value || !value.trim()) {
                        return Promise.reject(
                          new Error("Suggestion is required")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Write your suggestion here..."
                />
              </Form.Item>

              <Form.Item>
                <Button htmlType="submit" className="Fill-button">
                  Submit Suggestion
                </Button>
              </Form.Item>
            </Form>
          </div>

          {/* Past Suggestions */}
          <div className="suggestions-list-div">
            <h2>Community Suggestions</h2>
            <List
              itemLayout="vertical"
              dataSource={suggestions}
              renderItem={(item, index) => (
                <List.Item key={index}>
                  <strong>{item.name}:</strong> {item.text}
                </List.Item>
              )}
            />
          </div>
        </div>
      </section>
    </Main>
  );
}

export default SuggestionsPage;
